export interface News {
  newsFeed: [
    {
      align: string;
      date: Date;
      description: string;
      displayItems: [];
      heading: string;
      image: {
        Alt?: string;
        Border?: string;
        Class?: string;
        HSpace?: number;
        Height?: number;
        Language?: {};
        MediaId?: string;
        Src: string;
        Title?: string;
        VSpace?: number;
        Width?: number;
      };
      text: string;
      title: string;
    }
  ];
  pageName: string;
}
